import React from 'react'
import intl from 'react-intl-universal';
import '@/assets/css/story.scss';
const News = () => {
    return (
        <div className="rl">
            <div className="rl-story flex-column-center">
                <div className="story padding item1">
                    <div className="story-item flex-column-bwt">
                        <div className="item-top flex-column">
                            <div className="img-box">
                                <div className="img">
                                    <img src="https://yunhong-rt.oss-cn-shanghai.aliyuncs.com/rt-pc/story/story.png" alt=""/>
                                </div>
                            </div>
                            <div className="img-box">
                                <div className="img">
                                    <img src="https://yunhong-rt.oss-cn-shanghai.aliyuncs.com/rt-mobile/story/02.png" alt=""/>
                                </div>
                            </div>
                        </div>
                        <div className="item-bottom des">
                            {
                                intl.get('storyArray')[0].des.map(val => {
                                    return (
                                        <p key={val}>{val}</p>
                                    )
                                })
                            }
                        </div>
                    </div>
                </div>
                <div className="story padding item2">
                    <div className="story-item flex-column-bwt">
                        <div className="story-img">
                            <img src="https://yunhong-rt.oss-cn-shanghai.aliyuncs.com/rt-mobile/story/03.jpg" alt=""/>
                        </div>
                        <div className="story-text">
                            <h3 className="title">{intl.get('storyArray')[1].text}</h3>
                            <div className="des">
                                {
                                    intl.get('storyArray')[1].des.map(val => {
                                        return (
                                            <p key={val}>{val}</p>
                                        )
                                    })
                                }
                            </div>
                        </div>
                    </div>
                </div>
                <div className="story cel item3">
                    <div className="story-item">
                        <div className="info">
                            <div className="title">
                                {intl.get('storyArray')[2].text}
                            </div>
                            <div className="des">
                                {
                                    intl.get('storyArray')[2].des.map(val => {
                                        return (
                                            <p key={val}>{val}</p>
                                        )
                                    })
                                }
                            </div>
                        </div>
                    </div>
                </div>
                <div className="story padding item4">
                    <div className="story-item flex-column-bwt">
                        <div className="story-info flex-column">
                            <div className="info-img">
                                <div className="img">
                                    <img src="https://yunhong-rt.oss-cn-shanghai.aliyuncs.com/rt-mobile/story/05.jpg" alt=""/>
                                </div>
                            </div>
                            <div className="info-text">
                                <div className="title">
                                    <img src="https://yunhong-rt.oss-cn-shanghai.aliyuncs.com/rt-mobile/story/dis.png" alt=""/>
                                </div>
                                <div className="des">
                                    {
                                        intl.get('storyArray')[3].des.map(val => {
                                            return (
                                                <p key={val}>{val}</p>
                                            )
                                        })
                                    }
                                </div>
                            </div>
                        </div>
                        <div className="story-info flex-column">
                            <div className="info-img">
                                <div className="img">
                                    <img src="https://yunhong-rt.oss-cn-shanghai.aliyuncs.com/rt-mobile/story/06.jpg" alt=""/>
                                </div>

                            </div>
                            <div className="info-text">
                                <div className="title">
                                    <img src="https://yunhong-rt.oss-cn-shanghai.aliyuncs.com/rt-mobile/story/dayin.png" alt=""/>
                                </div>
                                <div className="des">
                                    {
                                        intl.get('storyArray')[4].des.map(val => {
                                            return (
                                                <p key={val}>{val}</p>
                                            )
                                        })
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="story cel item5">
                    <div className="story-item">
                        <div className="info flex-column-center">
                            <div className="title">
                                {intl.get('storyArray')[5].text}
                            </div>
                            <div className="des">
                                {
                                    intl.get('storyArray')[5].des.map(val => {
                                        return (
                                            <p key={val}>{val}</p>
                                        )
                                    })
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default News
